import { CONTACT_INFO } from "../constents/contactInfo";

const isBrowser = typeof window !== "undefined";

const storage = {
  get(key) {
    if (!isBrowser) {
      return null;
    }
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      console.warn(`Unable to read ${key} from storage`, error);
      return null;
    }
  },
  set(key, value) {
    if (!isBrowser) {
      return;
    }
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      console.warn(`Unable to write ${key} to storage`, error);
    }
  },
};

const LANGUAGE_TO_LOCALE = {
  EN: "en-US",
  GE: "de-DE",
  FR: "fr-FR",
};

const DEFAULT_LANGUAGE = storage.get("appLanguage") || "EN";
const DEFAULT_BASE_CURRENCY = (process.env.VUE_APP_BASE_CURRENCY || "EUR").toUpperCase();
const DEFAULT_CURRENCY = (storage.get("appCurrency") || DEFAULT_BASE_CURRENCY).toUpperCase();

const cloneContactInfo = () => ({
  ...CONTACT_INFO,
  socials: CONTACT_INFO.socials.map((social) => ({ ...social })),
});

export const application = {
  state: () => ({
    breadcrumb: [],
    contactInfo: cloneContactInfo(),
    settings: {
      websiteName: "viabrera",
    },
    locale: LANGUAGE_TO_LOCALE[DEFAULT_LANGUAGE] || "en-US",
    language: DEFAULT_LANGUAGE,
    currency: DEFAULT_CURRENCY,
    baseCurrency: DEFAULT_BASE_CURRENCY,
    currentActiveModal: "",
  }),
  mutations: {
    setLocation(state, payload) {
      state.breadcrumb = payload;
    },
    setCurrency(state, payload) {
      if (!payload) {
        return;
      }
      const normalised = payload.toUpperCase();
      state.currency = normalised;
      storage.set("appCurrency", normalised);
    },
    setLanguage(state, payload) {
      state.language = payload;
      storage.set("appLanguage", payload);
      // Update locale based on language selection
      state.locale = LANGUAGE_TO_LOCALE[payload] || "en-US";
    },
    toggleModal(state, payload) {
      if (state.currentActiveModal === payload) {
        state.currentActiveModal = ""
      } else {
        state.currentActiveModal = payload;
      }
    },
    forceCloseModal(state) {
      state.currentActiveModal = "";
    }
  },

  actions: {},
  getters: {
    modalIsQuickView: (state) => {
      return state.currentActiveModal.includes('qv');
    },
  },
};
